import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ElectricBlanketIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ElectricBlanketIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.4243 15.1274C22.4243 13.1049 20.7788 11.4594 18.7563 11.4594H13.1578V6.55592C13.1578 6.02368 13.5908 5.59066 14.1231 5.59066H14.3744C14.6434 6.91082 15.8134 7.90728 17.2119 7.90728H19.5285C21.1252 7.90728 22.4243 6.60823 22.4243 5.0115C22.4243 3.41477 21.1252 2.11572 19.5285 2.11572H17.2119C15.8134 2.11572 14.6434 3.11218 14.3744 4.43234H14.1231C12.9521 4.43234 11.9995 5.38497 11.9995 6.55591V11.4594H10.069V8.56364C10.069 7.3927 9.11633 6.44007 7.94539 6.44007H7.5755C7.33642 5.76597 6.69267 5.28176 5.93765 5.28176H4.77934C4.45949 5.28176 4.20018 5.54107 4.20018 5.86092V6.44008H3.23492C2.91507 6.44008 2.65576 6.69939 2.65576 7.01924C2.65576 7.33909 2.91507 7.5984 3.23492 7.5984H4.20018V8.17756C4.20018 8.49741 4.45949 8.75672 4.77934 8.75672H5.93765C6.69268 8.75672 7.33643 8.27251 7.5755 7.59841H7.94539C8.47763 7.59841 8.91065 8.03142 8.91065 8.56367V11.4595H6.40098C5.23004 11.4595 4.27741 12.4121 4.27741 13.583C4.27741 14.096 4.46027 14.567 4.76413 14.9344C3.56103 15.5369 2.73299 16.7816 2.73299 18.2163C2.73299 20.2388 4.37845 21.8842 6.40097 21.8842H20.3007C21.4716 21.8842 22.4243 20.9316 22.4243 19.7607C22.4243 18.9177 21.9305 18.1879 21.217 17.8452C21.958 17.1736 22.4243 16.2039 22.4243 15.1274ZM17.2119 3.27404H19.5285C20.4865 3.27404 21.266 4.05347 21.266 5.01151C21.266 5.96955 20.4865 6.74898 19.5285 6.74898H17.2119C16.2538 6.74898 15.4744 5.96955 15.4744 5.01151C15.4744 4.05347 16.2538 3.27404 17.2119 3.27404ZM5.93765 7.59839H5.35849V6.44008H5.93765C6.257 6.44008 6.51681 6.69989 6.51681 7.01924C6.51681 7.33859 6.257 7.59839 5.93765 7.59839ZM18.7563 17.6371H6.78708C6.46723 17.6371 6.20792 17.8964 6.20792 18.2162C6.20792 18.5361 6.46723 18.7954 6.78708 18.7954H20.3007C20.8329 18.7954 21.266 19.2284 21.266 19.7607C21.266 20.2929 20.833 20.7259 20.3007 20.7259H6.40098C5.01715 20.7259 3.89131 19.6001 3.89131 18.2163C3.89131 16.8324 5.01715 15.7066 6.40098 15.7066H18.3702C18.69 15.7066 18.9494 15.4473 18.9494 15.1274C18.9494 14.8076 18.69 14.5483 18.3702 14.5483H6.40098C5.86874 14.5483 5.43572 14.1153 5.43572 13.583C5.43572 13.0508 5.86873 12.6177 6.40098 12.6177H18.7563C20.1401 12.6177 21.266 13.7436 21.266 15.1274C21.266 16.5112 20.1401 17.6371 18.7563 17.6371Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.5284 5.59045C19.8482 5.59045 20.1075 5.33115 20.1075 5.01129C20.1075 4.69143 19.8482 4.43213 19.5284 4.43213C19.2085 4.43213 18.9492 4.69143 18.9492 5.01129C18.9492 5.33115 19.2085 5.59045 19.5284 5.59045Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.212 5.59045C17.5318 5.59045 17.7911 5.33115 17.7911 5.01129C17.7911 4.69143 17.5318 4.43213 17.212 4.43213C16.8921 4.43213 16.6328 4.69143 16.6328 5.01129C16.6328 5.33115 16.8921 5.59045 17.212 5.59045Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ElectricBlanketIcon;
